<template>
  <el-dialog title="Warning: Incompatible Browser"
    :visible.sync="browserWarnVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    :show-close="true"
    :model="true">
    <template>
      Your current browser has been flagged as not fully compatible with PEA. (Internet Explorer)
      <br /><br />
      It is recommended you use a different browser.
      <br /> <br />
      You may try to continue using this browser but will experience issues.
      <br /> <br />
      <el-button type="primary" @click="browserWarnVisible = false">Close</el-button>
    </template>
  </el-dialog>
</template>

<script>
import store from '../../state/store.js'
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'browser-check',
  data () {
    return {
      browserWarnVisible: false
    }
  },
  methods: {
    checkBrowser () {
      if (!store.getters.browserCheck || store.getters.browserCheck === 'false' || store.getters.browserCheck === null) {
        var browser = helperMethods.getBrowser()
        // IE 9 or lower not suppored
        if (browser.name === 'MSIE' || browser.name === 'IE') {
          this.browserWarnVisible = true
        }
        // prevent showing popup rest of this session
        store.commit('setBrowserCheck', true)
      }
    }
  },
  created: function () {
    this.checkBrowser()
  }
}

</script>

<style scoped>
.el-dialog--small {
  width: 500px;
  text-align: center;
}
.el-dialog__wrapper {
  z-index: 4000 !important;
}
</style>
